export default {
  'component.globalHeader.search': 'Pesquisar',
  'component.globalHeader.search.example1': 'Exemplo de pesquisa 1',
  'component.globalHeader.search.example2': 'Exemplo de pesquisa 2',
  'component.globalHeader.search.example3': 'Exemplo de pesquisa 3',
  'component.globalHeader.help': 'Ajuda',
  'component.globalHeader.notification': 'Notificação',
  'component.globalHeader.notification.empty':
    'Você visualizou todas as notificações.',
  'component.globalHeader.message': 'Mensagem',
  'component.globalHeader.message.empty': 'Você visualizou todas as mensagens.',
  'component.globalHeader.event': 'Evento',
  'component.globalHeader.event.empty': 'Você visualizou todos os eventos.',
  'component.noticeIcon.clear': 'Limpar',
  'component.noticeIcon.cleared': 'Limpo',
  'component.noticeIcon.empty': 'Nenhuma notificação',
  'component.noticeIcon.view-more': 'Ver mais',
};